export const SET_CATALOGUES = 'catalogues/SET_CATALOGUES';
export const CLEAR_CATALOGUES = 'catalogues/CLEAR_CATALOGUES';
export const SET_LISTA_CATALOGUES = 'SET_LISTA_CATALOGUES';
export const RESET_LISTA_CATALOGUES = 'RESET_LISTA_CATALOGUES';
export const SET_SELECTED_CATALOGUE = 'SET_SELECTED_CATALOGUE';
export const SET_SELECTED_CATALOGUES = 'SET_SELECTED_CATALOGUES'; 